export default {
  FETCH_SUBORDINATE_LIST_REQUEST: 'FETCH_SUBORDINATE_LIST_REQUEST',
  FETCH_SUBORDINATE_LIST_SUCCESS: 'FETCH_SUBORDINATE_LIST_SUCCESS',
  FETCH_SUBORDINATE_LIST_FAILURE: 'FETCH_SUBORDINATE_LIST_FAILURE',

  SELECT_RETAILER: 'SELECT_RETAILER',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/actions/action-types.js